export class CreateAccountCourse {
  courseId: string;
  levelId: string;
}
